import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"

import ModalCreateSampleRound from "../ModalCreateSampleRound"
import { LanzaTable } from "../../../../shared_components/widgets/LanzaTable"
import { API_STATUS, listUtils } from "../../../../shared_components/widgets/utils"
import PageLoadingPanel from "../../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../../shared_components/widgets/PageErrorPanel"
import { withSampleConfig } from "../../../../config/SampleConfigProvider"
import { showModal, hideModal } from "../../../../shared_components/utils"
import { getFormattedMessage } from "../../../shared_components_registration"
import { getLocaleFormattedUserString } from "../../../internationalization/LocaleFormatted"

/* Table for Sample Round Templates */
const TableSampleRoundTemplate = ({
  getSampleRoundTemplates,
  sample_template_data,
  sample_template_status,
  sample_template_delete_status,
  deleteSampleRoundTemplate,
  user_permissions = [],
  getReactors,
  reloadSampleRoundsTable,
  reloadSampleTable,
}) => {
  const intl = useIntl()

  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [createSampleRoundModal, setCreateSampleRoundModal] = useState(false)

  useEffect(() => {
    getSampleRoundTemplates()
  }, [])

  useEffect(() => {
    if (sample_template_status === API_STATUS.ERROR) {
      alert(intl.formatMessage({ id: "general.server.error" }))
    }
  }, [sample_template_status])

  useEffect(() => {
    if (sample_template_delete_status === API_STATUS.ERROR) {
      alert(intl.formatMessage({ id: "samplemanagement.unable.to.delete.sample.template" }))
    }
  }, [sample_template_delete_status])

  const deleteSampleTemplate = (template) => {
    if (
      !confirm(
        `${intl.formatMessage({
          id: "samplemanagement.confirm.delete.sample.template",
        })}:\n ${template.name}`,
      )
    ) {
      return false
    }

    deleteSampleRoundTemplate(template.id, {})
  }

  const columns = [
    {
      Header: "",
      id: "delete_template",
      disableSortBy: true,
      disableFilters: true,
      className: "text-center",
      accessor: (row) => {
        return (
          <Button
            variant={"outline-primary"}
            className={"btn btn-sm"}
            disabled={!user_permissions.includes("delete_sampleroundtemplate")}
            onClick={() => deleteSampleTemplate(row)}
          >
            <span className={"fa fa-trash-o text-danger"} />
          </Button>
        )
      },
    },
    {
      Header: <FormattedMessage id={"general.id"} />,
      accessor: "id",
    },
    {
      Header: <FormattedMessage id={"samplemanagement.template.name"} />,
      accessor: "name",
    },
    {
      Header: <FormattedMessage id={"general.reactor"} />,
      id: "reactors",
      accessor: "sampling_point_list",
      Cell: ({ value }) => {
        return getReactors(value, "V1").join(", ")
      },
    },
    {
      Header: <FormattedMessage id={"samplemanagement.sampling.points"} />,
      id: "sampling_points",
      accessor: "sampling_point_list",
      Cell: ({ value }) => {
        return listUtils
          .removeDuplicates(
            value.map((sampling_pt) => {
              return sampling_pt["sample_conn_no"]
            }),
          )
          .join(", ")
      },
    },
    {
      Header: <FormattedMessage id={"samplemanagement.frequency"} />,
      id: "frequencies",
      className: "text-center",
      accessor: "sampling_point_list",
      Cell: ({ value }) => {
        return listUtils
          .removeDuplicates(
            value.map((sampling_pt) => {
              return sampling_pt.frequency
            }),
          )
          .join(", ")
      },
    },
    {
      Header: <FormattedMessage id={"general.usage.count"} defaultMessage={"Usage count"} />,
      id: "usage_count",
      className: "text-center",
      accessor: "usage_count",
    },
    {
      Header: <FormattedMessage id={"general.operator"} />,
      id: "operator",
      className: "text-center",
      accessor: "created_by",
      Cell: ({ value }) => getLocaleFormattedUserString(value, intl),
    },
    {
      Header: "",
      id: "actions",
      className: "text-center",
      accessor: (row) => {
        return (
          <>
            <Button
              variant={"outline-primary"}
              size={"sm"}
              style={{ fontSize: "90%" }}
              id={"btn_startRound_" + row.id}
              disabled={!user_permissions.includes("add_sampleround")}
              onClick={(evt) => {
                evt.preventDefault()
                showModal(setCreateSampleRoundModal)
                setSelectedTemplate(row)
              }}
            >
              <span className={"fa fa-play"} />
              &nbsp;
              {getFormattedMessage("general.start", "Start")}
            </Button>
          </>
        )
      },
      disableSortBy: true,
      disableFilters: true,
    },
  ].map((col) => {
    return {
      ...col,
      style: { fontSize: "90%", ...(col["style"] || {}) },
    }
  })

  return (
    <>
      {sample_template_status === API_STATUS.LOADING ? (
        <PageLoadingPanel />
      ) : sample_template_status === API_STATUS.ERROR ? (
        <PageErrorPanel attemptReload={getSampleRoundTemplates} />
      ) : (
        sample_template_status === API_STATUS.SUCCESS && (
          <LanzaTable
            name={"Sample Round Template Table"}
            className={"table table-bordered table-sm table-hover tbl_lanzatable"}
            columns={columns}
            data={sample_template_data}
            allowSorting={true}
            initialTableOptions={{
              sortBy: [{ id: "usage_count", desc: true }],
              pageSize: 20,
            }}
          />
        )
      )}

      {/*---------- Modal ----------*/}
      {selectedTemplate && (
        <ModalCreateSampleRound
          show={createSampleRoundModal}
          onHide={() => {
            hideModal(setCreateSampleRoundModal)
            setSelectedTemplate(null)
          }}
          onSuccess={() => {
            hideModal(setCreateSampleRoundModal)
            setSelectedTemplate(null)
            reloadSampleRoundsTable()
            reloadSampleTable()
            getSampleRoundTemplates() // Add this to reload the templates table
          }}
          sampleroundTemplate={selectedTemplate}
        />
      )}
      {/*---------- /Modal ----------*/}
    </>
  )
}

export default withSampleConfig(TableSampleRoundTemplate)
